import React from 'react';
import PropTypes from 'prop-types';
import { Spinner as BootstrapSpinner } from 'react-bootstrap';
import SpinnerTitle from './SpinnerTitle';
import SpinnerDescription from './SpinnerDescription';

/**
 * see [react-bootstrap - Spinners](https://getbootstrap.com/docs/4.5/components/spinners/) for complete documentation on the underlying implementation
 */
export default function Spinner({ className, variant, size, inline, as: Component = inline ? 'span' : 'div', ...props }) {
	const wrapperClasses = [!inline && 'spinner'].filter(Boolean).join(' ');

	return (
		<Component className={wrapperClasses} data-testid={props['data-testid']}>
			<BootstrapSpinner className={className} variant={variant} size={size} animation="border" role="status">
				<span className="visually-hidden">Loading...</span>
			</BootstrapSpinner>
			{props.children}
		</Component>
	);
}

Spinner.propTypes = {
	/**
	 * class name for a bootstrap spinner component
	 */
	className: PropTypes.string,
	/**
	 * test id for spinner
	 */
	'data-testid': PropTypes.string,

	/**
	 * primary loading text for the spinner
	 */
	children: PropTypes.node,

	/**
	 * spinner color variation
	 */
	variant: PropTypes.string,

	/**
	 * flag to display spinner inline with another element/text
	 */
	inline: PropTypes.bool,

	/**
	 * spinner size variation
	 */
	size: PropTypes.oneOf(['sm']),

	as: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};

Spinner.defaultProps = {
	variant: 'primary'
};

Spinner.Title = SpinnerTitle;
Spinner.Description = SpinnerDescription;
